<mat-card>
  <mat-card-content>
    <p>{{ label() }}</p>
    <h3>{{ value() }}</h3>
  </mat-card-content>
</mat-card>
